import { useNavigate } from 'react-router-dom';

import { Button } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';

const ArrowLeftIcon = () => (
  <FontAwesomeIcon
    iconName="chevron-left"
    height="16px"
    iconType={CATEGORIES.SOLID}
  />
);

export const BackButton = ({ isFixed }) => {
  const navigate = useNavigate();
  const { actions } = useBooking();

  const goBack = () => {
    actions.reset({}).then(() => navigate('../registration'));
  };

  return (
    <Button
      onClick={() => goBack()}
      variant="secondary"
      icon={!isFixed ? ArrowLeftIcon : undefined}
    >
      {isFixed
        ? s__('NetworkEvents|Back')
        : s__('NetworkEvents|Go back to Registration')}
    </Button>
  );
};
